import { useStore } from 'react-admin';
import { Box, Button, ButtonGroup } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { AnimationList } from './list/AnimationList';
import { AnimationInventoryByAntenna } from './inventory/AnimationInventoryByAntenna';

type AnimationTabView = 'list' | 'inventory';

export const AnimationTab = () => {
    const [animationTabView, setAnimationTabView] = useStore<AnimationTabView>(
        'animationTabView',
        'list'
    );

    return (
        <Box>
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <ButtonGroup size="small" variant="outlined">
                    <Button
                        onClick={() => setAnimationTabView('list')}
                        startIcon={<ViewListIcon />}
                        variant={
                            animationTabView === 'list'
                                ? 'contained'
                                : 'outlined'
                        }
                    >
                        List
                    </Button>
                    <Button
                        onClick={() => setAnimationTabView('inventory')}
                        startIcon={<Inventory2OutlinedIcon />}
                        variant={
                            animationTabView === 'inventory'
                                ? 'contained'
                                : 'outlined'
                        }
                    >
                        Inventory by antenna
                    </Button>
                </ButtonGroup>
            </Box>

            <Box sx={{ width: '100%', marginTop: '-20px' }}>
                {animationTabView === 'list' && <AnimationList />}
                {animationTabView === 'inventory' && (
                    <AnimationInventoryByAntenna />
                )}
            </Box>
        </Box>
    );
};
